import { Injectable } from '@angular/core';
import { URL_BASE } from '../../core/constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtils } from '../../shared/http-utils';
import { CicoHelpConfigurationFile } from './cico-help-configuration-file.model';
import { map } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class CicoHelpConfigurationService {

  private CICO_HELP_CONFIGURATION_URI = `${URL_BASE}/api/cico-help/configuration`;

  constructor(private http: HttpClient) {}

  public downloadFile(): Observable<CicoHelpConfigurationFile> {
    const headers = HttpUtils.createHeaders();
    const url = `${this.CICO_HELP_CONFIGURATION_URI}`;

    return this.http.get<CicoHelpConfigurationFile>(`${url}/download`, { headers })
      .pipe(map(result => CicoHelpConfigurationFile.fromDto(result)));
  }

  public uploadFile(file: File): Observable<CicoHelpConfigurationFile> {
    const headers = HttpUtils.createHeaders();
    const url = `${this.CICO_HELP_CONFIGURATION_URI}`;
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<CicoHelpConfigurationFile>(`${url}/upload`, formData, { headers })
      .pipe(map(result => CicoHelpConfigurationFile.fromDto(result)));
  }
}
